Vendd.Scripts.load(function () {
    "use strict";

    var $wrapper = $('.js-login-order-edit-form'), wrapper, model;

    if ($wrapper.length < 1) return;

    wrapper = $wrapper.get(0);

    var orderModel = sessionStorage.getItem('OrderLoginReturnModel');

    wrapper.bind = function () {

        var parsedFormHtml = Vendd.Handlebars.parse('loginOrderEditForm_A', model);

        $wrapper.html(parsedFormHtml);

        $('.js-voucher-accordion', $wrapper).on('click', function (e) {
            var $voucherTable = $(this).closest('.voucher-table');
            var $voucherList = $('.voucher-list', $voucherTable);

            if ($voucherList.hasClass('hidden')) {
                $voucherList.removeClass('hidden');
                $(this).removeClass('icon-arrow-down').addClass('icon-arrow-up');
            } else {
                $voucherList.addClass('hidden');
                $(this).removeClass('icon-arrow-up').addClass('icon-arrow-down');
            }
        });

        //CAUTION - /page/ in URLs may not be necessary
        $('.js-new-order-login', $wrapper).on('click', function (e) {
            sessionStorage.removeItem('prevGlobalId');
            sessionStorage.removeItem('OrderLoginReturnModel');

            window.location.href = venddProjectConfigs.OrderManagement.loginOrderUrl;
        });

        $('.js-return-request', $wrapper).on('click', function (e) {
            window.location.href = venddProjectConfigs.OrderManagement.requestReturnUrl;
        });

        $('.js-cancel-order', $wrapper).on('click', function (e) {
            window.location.href = venddProjectConfigs.OrderManagement.cancelOrderUrl;
        });
    };

    if (orderModel && orderModel !== "undefined") {
        model = JSON.parse(orderModel);

        wrapper.bind();
    }

    wrapper.onFailure = function () {

        $('> .form-error', $wrapper).hide();
        $wrapper.removeClass('x-loading');
        var localError = $('.submit-order-return-container .form-error.js-error-appended', $wrapper);
        if (localError.length < 1) {
            $('.submit-order-return-container', $wrapper).prepend('<div class="form-error js-error-appended"><span class="font-icon icon-info"></span>' + LhApp.Function.getText("Common:ReturnFormGenericError") + '</div>');
        } else {
            localError.show();
        }

    };

    Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrderSuccess, wrapper, function (envelope) {
        model = envelope.message.data;

        sessionStorage.setItem('OrderLoginReturnModel', JSON.stringify(model));
        wrapper.bind();
        $wrapper.removeClass('x-loading');
    });

    Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrderFailure, wrapper, function (envelope) {
        sessionStorage.setItem('OrderLoginReturnModel', JSON.stringify(model));
        wrapper.onFailure();
    });

    Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrderError, wrapper, function (envelope) {
        sessionStorage.setItem('OrderLoginReturnModel', JSON.stringify(model));
        wrapper.onFailure();
    });
});
